import clsx from 'clsx';

import { twMerge } from '../../../../../utils/twMerge';
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from '../../../Icons';
import type { CalloutProps } from '../../callout.types';
import { CalloutType } from '../../callout.types';

interface Props extends Pick<CalloutProps, 'type' | 'overrides'> {}

const TYPE_COLOR: Partial<Record<CalloutType, string>> = {
  [CalloutType.INFO]: 'text-icon-info dark:text-[var(--tw-blue-40)]',
  [CalloutType.ERROR]: 'text-icon-danger dark:text-[var(--tw-red-40)]',
  [CalloutType.WARNING]: 'text-icon-warning dark:text-[var(--tw-yellow-40)]',
  [CalloutType.SUCCESS]: 'text-icon-success dark:text-[var(--tw-green-40)]',
};

export const CalloutIcon = ({ type, overrides }: Props) => {
  const renderIcon = () => {
    if (overrides?.Icon) {
      const CustomIcon = overrides.Icon;
      return <CustomIcon />;
    }
    switch (type) {
      case CalloutType.INFO:
        return <InfoIcon />;
      case CalloutType.ERROR:
        return <ErrorIcon />;
      case CalloutType.WARNING:
        return <WarningIcon />;
      case CalloutType.SUCCESS:
        return <SuccessIcon />;
      case CalloutType.NEUTRAL:
        return <InfoIcon />;
    }
  };

  if (!type) {
    return null;
  }

  const colorClass = type ? TYPE_COLOR[type] : undefined;

  return (
    <span
      className={twMerge(
        clsx('inline-flex items-center justify-center h-min', colorClass),
      )}
      style={overrides?.iconColor ? { color: overrides.iconColor } : undefined}
    >
      {renderIcon()}
    </span>
  );
};
